import { render, staticRenderFns } from "./AbastecimentoSinteticoRead.vue?vue&type=template&id=01495b6e&"
import script from "./AbastecimentoSinteticoRead.vue?vue&type=script&lang=js&"
export * from "./AbastecimentoSinteticoRead.vue?vue&type=script&lang=js&"
import style0 from "./AbastecimentoSinteticoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports